// Main entry point for Valentine Farm Game
// Using Three.js for 3D Township-style rendering

import { Game } from './Engine/Game';
import { ExperienceService } from './services/ExperienceService';

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', async () => {
    const container = document.getElementById('game-container');

    if (!container) {
        console.error('Game container not found!');
        return;
    }

    // Routing Logic
    const subdomain = getSubdomain();

    // Check for "Payment Success" param to show confetti or thank you?
    // Not implemented yet, usually handled by LandingPage if we redirect there? 
    // Or if we redirect to game, we handle it here.

    if (!subdomain) {
        console.log('🏠 Loading Creator Landing Page');
        import('./creator/LandingPage').then(({ LandingPage }) => {
            const landing = new LandingPage(container);
            landing.render();
        });
    } else {
        console.log(`🔍 Checking world for subdomain: ${subdomain}`);

        // Show loading state
        container.innerHTML = `
            <div style="
                position: absolute; top: 0; left: 0; width: 100%; height: 100%;
                display: flex; justify-content: center; align-items: center;
                background: linear-gradient(135deg, #fff0f5 0%, #fff 100%);
                font-family: 'Outfit', sans-serif; flex-direction: column;
            ">
                <div style="font-size: 24px; color: #ff6b9d; font-weight: 600;">Entering World... 🌍</div>
            </div>
        `;

        try {
            const result = await ExperienceService.getExperienceBySubdomain(subdomain);

            if (result.success && result.config) {
                console.log(`🎮 Loading Game for: ${result.config.subdomain}`);
                // Clear loading
                container.innerHTML = '';
                // Initialize the Game with config
                document.body.classList.add('game-mode'); // Lock scroll for game
                Game.create(container, result.config);
            } else {
                // 404
                render404(container, subdomain);
            }
        } catch (e) {
            console.error('Failed to load experience:', e);
            render404(container, subdomain);
        }
    }
});

function getSubdomain(): string | null {
    const host = window.location.hostname;
    const urlParams = new URLSearchParams(window.location.search);
    const querySubdomain = urlParams.get('subdomain');

    // Dev override via query param
    if (querySubdomain) {
        return querySubdomain;
    }

    // Handle localhost for testing
    // e.g., 'tomi.localhost' -> 'tomi'
    if (host.includes('localhost') || host.includes('127.0.0.1')) {
        const parts = host.split('.');
        // localhost or 127.0.0.1 -> null
        if (parts.length === 1 || !isNaN(Number(parts[parts.length - 1]))) {
            return null;
        }
        // test.localhost -> test
        return parts[0] !== 'www' ? parts[0] : null;
    }

    // Production: tomi.cupidplan.com
    const parts = host.split('.');
    // Assuming format: [subdomain].[domain].[tld]
    if (parts.length > 2) {
        if (parts[0] !== 'www') {
            return parts[0];
        }
    }

    return null;
}

function render404(container: HTMLElement, subdomain: string) {
    container.innerHTML = `
        <div style="
            position: absolute; top: 0; left: 0; width: 100%; height: 100%;
            display: flex; justify-content: center; align-items: center;
            background: #fff; color: #333; font-family: 'Outfit', sans-serif;
            flex-direction: column; text-align: center; padding: 20px;
        ">
            <h1 style="color: #ff6b9d; font-size: 40px; margin-bottom: 20px;">404 💔</h1>
            <p style="font-size: 18px; color: #666; margin-bottom: 30px;">
                The world <strong>${subdomain}</strong> doesn't exist yet.
            </p>
            <a href="/" style="
                padding: 12px 30px; background: #ff6b9d; color: white;
                text-decoration: none; border-radius: 30px; font-weight: 600;
            ">Create Your Own</a>
        </div>
    `;
}
